import { useEffect, useState } from "react";
import * as S from "./MosaicoPageStyled";
import TextComponent from "../../text/text";
import Footer from "../../../components/footer/footer";
import useImagesLoaded from "../../../hooks/useImagesLoaded";
import LoadingOverlay from "../../../components/LoadingComponente/Loading";

const mosaicoLogo =
  "https://res.cloudinary.com/djg8c78mb/image/upload/v1746324712/mosaicoLogo1_ch206u.png";
const missao =
  "https://res.cloudinary.com/djg8c78mb/image/upload/v1746324732/missao_esc_cbj8c2.png";
const visao =
  "https://res.cloudinary.com/djg8c78mb/image/upload/v1746324740/visao_esc_mkssot.png";
const valores =
  "https://res.cloudinary.com/djg8c78mb/image/upload/v1746324742/valores_esc_ctntpz.png";
const pinheiro =
  "https://res.cloudinary.com/djg8c78mb/image/upload/v1746324653/pinheiro_ygxzo0.png";
const aspas =
  "https://res.cloudinary.com/djg8c78mb/image/upload/v1746324725/aspasPreta_khaua6.png";
const estrutura =
  "https://res.cloudinary.com/djg8c78mb/image/upload/v1746324729/LOTUS_PRETO_gdyvta.png";

const MosaicoPage: React.FC = () => {
  const handleProjetoClick = (route: string) => {
    window.location.href = route;
  };
  const [isMobile, setIsMobile] = useState(false);
  const [OpacityPin, setOpacityPin] = useState(false);
  const [onLoading, setOnLoading] = useState(true);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  useEffect(() => {
    setOpacityPin(window.innerWidth <= 1880);
  }, []);

  const imageUrls = [
    mosaicoLogo,
    missao,
    visao,
    valores,
    pinheiro,
    aspas,
    estrutura,
  ];

  const allImagesLoaded = useImagesLoaded(imageUrls);

  useEffect(() => {
    if (allImagesLoaded) {
      const timer = setTimeout(() => {
        setOnLoading(false);
        
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [allImagesLoaded]);

  return (
    <div style={{ backgroundColor: "#C2CFB4" }}>
      {onLoading && <LoadingOverlay />}

      <S.MainContainer>
        <S.VectorImage isMobile={OpacityPin} src={pinheiro} alt="pinheiro" />
        <S.SubTitleContainer>
          <S.ContainerTitleA>
            <S.SecaoInicialIcon src={aspas} />
            <S.SubTitleText>
              <TextComponent
                children={"O Mosaico é uma vitrine para expor"}
                type={"h1"}
              />
            </S.SubTitleText>
          </S.ContainerTitleA>
          <S.SubTitleText>
            <TextComponent
              children={"projetos sociais e culturais"}
              type={"h1"}
            />
            <TextComponent children={"de todas as áreas!"} type={"h1"} />
          </S.SubTitleText>
        </S.SubTitleContainer>
        <S.InitialTextContainer>
          <S.Line />
          <S.InitialText>
            O <strong style={{ fontStyle: "italic" }}>Mosaico</strong> é um
            espaço dedicado a exibir projetos inspiradores, conectando ideias a
            pessoas. <br />
            O projeto nasceu com o propósito de ser uma vitrine para projetos
            sociais e culturais de todas as áreas.
            <br />
            Acreditamos no poder da VISIBILIDADE, para promover MUDANÇAS e
            valorizar
            <br />
            IDEIAS QUE TRANSFORMAM O MUNDO.
          </S.InitialText>
        </S.InitialTextContainer>
        <S.CardTextContainer>
          <S.Card>
            <S.IconInicialCard src={estrutura} />
            <S.CardText>
              <p>
                <strong>AQUI</strong>, você encontra histórias que merecem ser
                contadas e projetos que estão mudando realidades.
              </p>
            </S.CardText>
          </S.Card>
        </S.CardTextContainer>
        <S.TexteContainer>
          <S.TitleContainer1>
            <S.TitleLogo1>
              <S.LogoImg src={mosaicoLogo} alt="mosaicoLogo" />
            </S.TitleLogo1>
            <S.TitleText2>
              <TextComponent
                children={"CRIAMOS UM ESPAÇO ONDE PROJETOS PODEM BRILHAR!"}
                type={"h1"}
              />
            </S.TitleText2>
          </S.TitleContainer1>
          <S.SubTextContainer>
            <S.SubTextText>
              alcançando públicos diversos e celebrando a diversidade de vozes e
              histórias que fazem
              <br />
              parte do nosso mundo.
            </S.SubTextText>
          </S.SubTextContainer>
        </S.TexteContainer>
        <S.PilaresListContainer>
          <S.PilaresListLine />
          <S.PilaresListItensContainer>
            <S.PilaresCard>
              <S.PilaresTitleContainer>
                <S.PilaresTitleIcon src={missao} height="2.5rem" alt="missao" />
                <S.PilaresTitleText>MISSÃO</S.PilaresTitleText>
              </S.PilaresTitleContainer>
              <S.PilaresTextContainer>
                <S.PilaresText>
                  Mostrar e valorizar projetos que inspiram.
                  <br />
                  Destacar e valorizar projetos que promovem impacto positivo na
                  sociedade, inspirando mudanças, preservação cultural e
                  inovação.
                </S.PilaresText>
              </S.PilaresTextContainer>
            </S.PilaresCard>
            <S.PilaresCard>
              <S.PilaresTitleContainer>
                <S.PilaresTitleIcon src={visao} height="2.5rem" alt="missao" />
                <S.PilaresTitleText>VISÃO</S.PilaresTitleText>
              </S.PilaresTitleContainer>
              <S.PilaresTextContainer>
                <S.PilaresText>
                  Ser a principal plataforma de projetos sociais e culturais.
                  <br />
                  Transformar o Mosaico na plataforma de referência para
                  projetos sociais, culturais, ambientais e educacionais,
                  conectando iniciativas a um público amplo e diversificado,
                  inspirando mudanças, colaborações e inovações.
                </S.PilaresText>
              </S.PilaresTextContainer>
            </S.PilaresCard>
            <S.PilaresCard>
              <S.PilaresTitleContainer>
                <S.PilaresTitleIcon
                  src={valores}
                  height="2.5rem"
                  alt="missao"
                />
                <S.PilaresTitleText>VALORES</S.PilaresTitleText>
              </S.PilaresTitleContainer>
              <S.PilaresTextContainer>
                <S.PilaresText>
                  <S.PilaresList>
                    <S.SubItenList>Inclusão:</S.SubItenList>
                    <S.PilaresText>
                      Todos os projetos, independentemente de tamanho,
                      localidade ou tema, são bem-vindos no Mosaico.
                      <br />A plataforma busca representar a diversidade,
                      abrindo espaço para vozes que frequentemente não têm
                      visibilidade.
                    </S.PilaresText>
                    <br />
                    <S.SubItenList>Diversidade:</S.SubItenList>
                    <S.PilaresText>
                      Promover iniciativas que representem a riqueza cultural,
                      ambiental e social.
                      <br />
                      Valorizar tradições, práticas locais e inovações que
                      destacam a pluralidade do país.
                      <br />
                      Priorizar projetos de diferentes regiões e contextos (ex.:
                      comunidades indígenas, rurais e urbanas).
                    </S.PilaresText>
                    <br />
                    <S.SubItenList>Inspiração:</S.SubItenList>
                    <S.PilaresText>
                      Motivar novas ideias e iniciativas, mostrando histórias de
                      sucesso e impacto social real.
                      <br />
                      Criar um ciclo de inovação social ao expor projetos que
                      transformam.
                      <br />
                      Ter uma seção de “Histórias que Inspiram” para
                      compartilhar o impacto concreto de projetos cadastrados.
                    </S.PilaresText>
                  </S.PilaresList>
                </S.PilaresText>
              </S.PilaresTextContainer>
            </S.PilaresCard>
          </S.PilaresListItensContainer>
        </S.PilaresListContainer>
      </S.MainContainer>
      <S.BigIconCardContainer>
        <S.BigIconCard>
          <S.BigIconCardTitle>
            <S.BigIconImgCard>
              <S.BigIconTextCard>!</S.BigIconTextCard>
            </S.BigIconImgCard>
            NOSSA MISSÃO É SIMPLES!
          </S.BigIconCardTitle>
          <S.BigIconText>
            Mostrar ao mundo iniciativas que{" "}
            <strong>inspiram, educam e conectam.</strong>
          </S.BigIconText>
        </S.BigIconCard>
      </S.BigIconCardContainer>
      <S.FinalContainer>
        <S.CheckCardsContainerTitle>
          No Brasil, projetos sociais e culturais frequentemente enfrentam
          barreiras como:
        </S.CheckCardsContainerTitle>
        <S.CheckCardsContainer>
          <S.CheckCard>
            <S.CheckCard1>
              <S.CheckCardTitleContainer>
                <S.CheckCardIcon />
                <S.CheckCardTextTitle>Baixa visibilidade</S.CheckCardTextTitle>
              </S.CheckCardTitleContainer>
              <S.CheckCardText>
                Muitas iniciativas incríveis permanecem desconhecidas devido à
                falta de plataformas adequadas para divulgação.
              </S.CheckCardText>
            </S.CheckCard1>
          </S.CheckCard>
          <S.CheckCard>
            <S.CheckCard1>
              <S.CheckCardTitleContainer>
                <S.CheckCardIcon />
                <S.CheckCardTextTitle>
                  Dificuldade de legitimação
                </S.CheckCardTextTitle>
              </S.CheckCardTitleContainer>
              <S.CheckCardText>
                Sem uma vitrine confiável, os projetos têm dificuldade de
                demonstrar credibilidade e atrair apoiadores.
              </S.CheckCardText>
            </S.CheckCard1>
          </S.CheckCard>
          <S.CheckCard>
            <S.CheckCard1>
              <S.CheckCardTitleContainer>
                <S.CheckCardIcon />
                <S.CheckCardTextTitle>
                  Conexão limitada com o público-alvo
                </S.CheckCardTextTitle>
              </S.CheckCardTitleContainer>
              <S.CheckCardText>
                Projetos transformadores não alcançam as comunidades ou
                audiências que poderiam se beneficiar diretamente de suas ações.
              </S.CheckCardText>
            </S.CheckCard1>
          </S.CheckCard>
        </S.CheckCardsContainer>
        <S.TitleContainer>
          <S.TitleText1>!</S.TitleText1>
          <S.TitleText>com o mosaico</S.TitleText>
        </S.TitleContainer>
      </S.FinalContainer>

      <S.MidContainer>
        <S.MidCardSection>
          <S.MidCard>
            <S.MidCardTextContainerA>
              <S.CheckCardTitleContainer>
                <S.CheckCardIcon2 />
                <S.CheckCardTextTitleA>
                  Exposição e Credibi
                  <wbr />
                  lidade
                </S.CheckCardTextTitleA>
              </S.CheckCardTitleContainer>
              <S.CheckCardText>
                O Mosaico funciona como uma vitrine confiável e profissional,
                ajudando projetos a ganharem reconhecimento.
              </S.CheckCardText>
            </S.MidCardTextContainerA>
          </S.MidCard>
        </S.MidCardSection>

        <S.MidCardSection1>
          <S.MidCard1>
            <S.MidCardTextContainer>
              <S.CheckCardTitleContainer>
                <S.CheckCardIcon2 />
                <S.CheckCardTextTitleA>Amplo Alcance</S.CheckCardTextTitleA>
              </S.CheckCardTitleContainer>
              <S.CheckCardText>
                Oferece um espaço digital para conectar iniciativas a pessoas e
                organizações interessadas em apoiá-las ou promovê-las.
              </S.CheckCardText>
            </S.MidCardTextContainer>
          </S.MidCard1>
        </S.MidCardSection1>
        <S.MidCardSection>
          <S.MidCard>
            <S.MidCardTextContainerA>
              <S.CheckCardTitleContainer>
                <S.CheckCardIcon2 />
                <S.CheckCardTextTitleA>Inspiração</S.CheckCardTextTitleA>
              </S.CheckCardTitleContainer>
              <S.CheckCardText>
                Projetos exibidos no Mosaico incentivam outros criadores e
                organizações a se envolverem em ações transformadoras.
              </S.CheckCardText>
            </S.MidCardTextContainerA>
          </S.MidCard>
        </S.MidCardSection>
        <S.MidCardSection1>
          <S.MidCard1>
            <S.MidCardTextContainer>
              <S.CheckCardTitleContainer>
                <S.CheckCardIcon2 />
                <S.CheckCardTextTitleA>
                  Fortaleci
                  <wbr />
                  mento de Identidades Locais
                </S.CheckCardTextTitleA>
              </S.CheckCardTitleContainer>
              <S.CheckCardText>
                Por meio da divulgação de projetos culturais e ambientais, a
                plataforma contribui para a preservação de tradições, histórias
                e práticas que refletem a diversidade.
              </S.CheckCardText>
            </S.MidCardTextContainer>
          </S.MidCard1>
        </S.MidCardSection1>
      </S.MidContainer>

      <S.MainContainer>
        <S.PilaresListContainer1>
          <S.PilaresListLine1 />
          <S.PilaresListItensContainer>
            <S.PilaresTitleContainer>
              <S.PilaresTitleText>
                POR QUE É IMPORTANTE QUE PROJETOS RECEBAM VISIBILIDADE?
              </S.PilaresTitleText>
            </S.PilaresTitleContainer>
            <S.PilaresCard1>
              <S.PilaresTitleContainer>
                <S.PilaresTitleText1>
                  • Impacto Social Ampliado:
                </S.PilaresTitleText1>
              </S.PilaresTitleContainer>
              <S.PilaresTextContainer>
                <S.PilaresText>
                  Projetos que ganham visibilidade têm maior alcance, aumentando
                  sua capacidade de promover mudanças em comunidades e grupos
                  beneficiados.
                </S.PilaresText>
              </S.PilaresTextContainer>
            </S.PilaresCard1>
            <S.PilaresCard1>
              <S.PilaresTitleContainer>
                <S.PilaresTitleText1>• Reconhecimento:</S.PilaresTitleText1>
              </S.PilaresTitleContainer>
              <S.PilaresTextContainer>
                <S.PilaresText>
                  A exposição ajuda iniciativas a serem valorizadas e
                  legitimadas, abrindo portas para colaborações, financiamentos
                  ou apoios institucionais.
                </S.PilaresText>
              </S.PilaresTextContainer>
            </S.PilaresCard1>
            <S.PilaresCard1>
              <S.PilaresTitleContainer>
                <S.PilaresTitleText1>• Inspiração:</S.PilaresTitleText1>
              </S.PilaresTitleContainer>
              <S.PilaresTextContainer>
                <S.PilaresText>
                  Projetos bem-sucedidos servem como exemplos motivadores para
                  outras iniciativas, criando um ciclo virtuoso de ações
                  transformadoras.
                </S.PilaresText>
              </S.PilaresTextContainer>
            </S.PilaresCard1>
          </S.PilaresListItensContainer>
        </S.PilaresListContainer1>
      </S.MainContainer>
      <S.ButtonContainer onClick={() => handleProjetoClick("/Projetos")}>
        <S.FinalButton>Conheça nossos Projetos</S.FinalButton>
      </S.ButtonContainer>
      <S.CreditosContainer>
        <S.CreditosTitle>Créditos</S.CreditosTitle>
        <S.CreditosList>
          <S.CreditosItem>
            <strong>Marylena Bukowski</strong> – Direção de Arte
          </S.CreditosItem>
          <S.CreditosItem>
            <strong>Pedro Fontana</strong> – Prod. Vz1Pr / Sound Designer
          </S.CreditosItem>
          <S.CreditosItem>
            <strong>Guará Estúdio</strong> – Design e Website
          </S.CreditosItem>
          <S.CreditosItem>
            <strong>Vitória Carvalho</strong> – Design
          </S.CreditosItem>
          <S.CreditosItem>
            <strong>Frank Castro Filho</strong> – Desenvolvimento de Código
          </S.CreditosItem>
          <S.CreditosItem>
            <strong>Agnes Schumacker</strong> – Assistente de Produção
          </S.CreditosItem>
        </S.CreditosList>
      </S.CreditosContainer>

      {!isMobile && <Footer isMosaico={true} />}
    </div>
  );
};

export default MosaicoPage;
